import { get } from 'lodash'

import { ONE_TIME_TRIGGER } from 'components/SegmentSelector/outreach-message-trigger-constants'

export const MODAL_CONFIG = {
  [ONE_TIME_TRIGGER]: {
    saveButtonText: 'Schedule',
    title: 'One-Time Message',
    enableTriggerSelector: false,
  },
  DEFAULT_TEXT: {
    saveButtonText: 'Schedule',
    title: 'Automated Message',
    enableTriggerSelector: true,
  },
}

const getModalConfig = (trigger) => get(MODAL_CONFIG, trigger, MODAL_CONFIG.DEFAULT_TEXT)

export default getModalConfig
